



let base_url: string = 'https://imake-app.com';

export const environment = {
  production: false,
  graphqlendpoint: `${base_url}:1114/graphql`,
  ApiEndPoint: `${base_url}:1114/api`,
  ApiEndPoint2: `${base_url}:1116/api`,
  products: 'http://backend.backend.satamall.satatechnologygroup.net:4200/products',
  google_api_key : "AIzaSyD_U2-w1Zald01AAXfi4vO6EH35YYc0-hM",
  paymob_accept_base_url: 'https://accept.paymob.com/api',
  paymob_api_key:
  'ZXlKMGVYQWlPaUpLVjFRaUxDSmhiR2NpT2lKSVV6VXhNaUo5LmV5SmpiR0Z6Y3lJNklrMWxjbU5vWVc1MElpd2ljSEp2Wm1sc1pWOXdheUk2TVRBeU5EYzFMQ0p1WVcxbElqb2lNVFl5TWpJMU1EUTFNUzR3TmpnMU1ESWlmUS5sYnh4WkNla1BJX3NhbExpYXprUXBWUHlPTnc3OTRwRnExT3I0YkVXRmlvTEQtTHA5ZDctN2RKNmllT2hEYjZUaXViWVdnOFpEWDl3cmFDYVpWNG5SQQ==',
  integrationId: '408709',
  iframeId: '238206',
  gaTRACKING: 'G-H3XJ0XPVZT'
,
  vendor_code: 'Gqtl0Vzb22342023'
  ,
  vendor_id: "460"
  ,
  site_name: 'taqwafoods'
  ,
  currency: 'EGP'

};
